import React from "react"

import { classNames } from "../../utils/class-names"
import Paragraph from "../paragraph"
import * as styles from "./index.module.scss"

interface Props {
  className?: string
  index: number
  tabIndex: number
  onClick: () => void
  children?: string
}

const Tab = ({
  className = "",
  onClick,
  index,
  tabIndex,
  children,
  ...otherProps
}: Props) => {
  const isActive = tabIndex === index
  return (
    <button
      className={classNames(
        styles.resetButton,
        styles.tab,
        isActive && styles.selected,
        className,
      )}
      onClick={onClick}
      type="button"
      role="tab"
      {...otherProps}
    >
      <Paragraph variant="1">
        {isActive ? <span>{children}</span> : children}
      </Paragraph>
    </button>
  )
}

export default Tab
